import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d656319"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center pb-lg-4 pb-3" }


export default /*#__PURE__*/_defineComponent({
  props: {
  title: String,
  className: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", {
      class: _normalizeClass(['pb-3 fs-5', __props.className])
    }, _toDisplayString(__props.title), 3)
  ]))
}
}

})